module.exports = __webpack_public_path__ + "static/media/dropdown.b51e8e56.svg";